(() => {
  const initNavigation = (nav) => {
    if (!nav || nav.dataset.initialized === "true") return;

    const buttons = [...nav.querySelectorAll("[data-gnr-target]")];
    if (!buttons.length) return;
    nav.dataset.initialized = "true";

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const stickySection = nav.closest(".shopify-section");
    const targets = buttons
      .map((button) => {
        const element = document.querySelector(button.dataset.gnrTarget);
        return element ? { button, element } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    let activeIndex = 0;
    let ticking = false;

    const setActive = (index) => {
      if (index < 0 || index >= targets.length) return;
      activeIndex = index;
      targets.forEach(({ button }, i) => {
        button.classList.toggle("is-active", i === index);
      });
    };

    /**
     * Keep sticky nav flush under the live site header
     * (desktop ~64px, compact/tablet/mobile ~51px; may vary with announcement bars).
     */
    const syncStickyTop = () => {
      if (!stickySection) return;
      const header = document.querySelector(".site-header");
      if (!header) return;
      const top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      stickySection.style.top = `${top}px`;
    };

    /**
     * Sticky nav sits below the site header.
     * Use its viewport bottom so header + nav are both cleared.
     */
    const updateActiveFromScroll = () => {
      const threshold = nav.getBoundingClientRect().bottom + 1;
      let nextActive = 0;

      targets.forEach(({ element }, index) => {
        if (element.getBoundingClientRect().top <= threshold) {
          nextActive = index;
        }
      });

      if (nextActive !== activeIndex) {
        setActive(nextActive);
      }
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        syncStickyTop();
        updateActiveFromScroll();
        ticking = false;
      });
    };

    const scrollToSection = (index) => {
      const target = targets[index];
      if (!target) return;

      syncStickyTop();
      const offset = nav.getBoundingClientRect().bottom;
      const top = window.scrollY + target.element.getBoundingClientRect().top - offset + 1;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: reducedMotion ? "auto" : "smooth",
      });

      setActive(index);
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const targetIndex = targets.findIndex(({ button: item }) => item === button);
        if (targetIndex < 0) return;
        scrollToSection(targetIndex);
      });
    });

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    syncStickyTop();
    setActive(0);
    updateActiveFromScroll();
  };

  const init = (scope = document) => {
    if (scope.matches?.("[data-gnr-nav]")) {
      initNavigation(scope);
    }
    scope.querySelectorAll?.("[data-gnr-nav]").forEach(initNavigation);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
